import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionBudgetStrategy' })
    .attrs({
        width: '100%',
    })``;

export const FieldsWrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionBudgetStrategyFieldsWrapper' })
    .attrs<{ isVertical: boolean }>((props) => ({
        direction: props.isVertical ? 'column' : 'row',
        spacing: props.isVertical ? 0 : 1,
        width: '100%',
    }))``;

export const Field = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionBudgetStrategyField' })
    .attrs<{ isVertical: boolean }>((props) => ({
        width: props.isVertical ? '100%' : '50%',
        py: 1,
        ...props,
    }))``;
